import { getControlPlaneRuntimeConfig } from "@/app/runtime-config";
import { applyControlAuthHeaders, ControlApiError } from "./client.js";

export async function orvalControlFetch<TData>(
  url: string,
  options?: RequestInit,
): Promise<TData> {
  const runtimeConfig = getControlPlaneRuntimeConfig();
  const baseUrl = runtimeConfig.apiBaseUrl?.trim() || "";
  const headers = new Headers(options?.headers);
  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }
  if (options?.method && options.method.toUpperCase() !== "GET" && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  applyControlAuthHeaders(headers);

  const response = await fetch(`${baseUrl}${url}`, {
    ...options,
    headers,
    credentials: "include",
  });
  if (!response.ok) {
    let errorBody: unknown;
    try {
      errorBody = await response.json();
    } catch {
      errorBody = await response.text().catch(() => null);
    }
    if (response.status === 401 && typeof window !== "undefined") {
      window.dispatchEvent(new Event("auth:unauthorized"));
    }
    throw new ControlApiError(response.status, `HTTP_${response.status}`, errorBody);
  }
  if (response.status === 204) {
    return undefined as TData;
  }
  return (await response.json()) as TData;
}
